import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentPage from '../../components/DocumentPage/DocumentPage';
import termsEn from '../../data/legal/privacy.en.json';
import termsRu from '../../data/legal/privacy.ru.json';

const PrivacyPolicy: React.FC = () => {
  const { i18n } = useTranslation();
  const content = i18n.language === 'ru' ? termsRu : termsEn;

  return <DocumentPage title={content.title} sections={content.sections} />;
};

export default PrivacyPolicy;
